import { createSelector } from 'reselect';
import IntrefSequenceVerificationColumns from '../../containers/IntrefSequenceVerificationColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.INTREF_SEQUENCE_VERIFICATION.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.INTREF_SEQUENCE_VERIFICATION.isLoading;

export const getData =
  ReportDefinitions.INTREF_SEQUENCE_VERIFICATION.getDataFunction();

export const getColumns =
  createSelector(getData, IntrefSequenceVerificationColumns);
